import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { FirmwareServiceProxy, IssueFirmwareDto } from '@/service-proxies/app-v2/console.service-proxies'
import { TenantGatewayServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { FirmwareServiceProxy as FirmwareService, IssueFirmwareDTO, GatewayServiceProxy, PageGatewayDTO } from '@/service-proxies/app-v2/iot-console.service-proxies'

const firmwareService = new FirmwareServiceProxy()
const tenantGatewayService = new TenantGatewayServiceProxy()
const fsp = new FirmwareService()
const gsp = new GatewayServiceProxy()

@Component
export default class UploadModal extends Vue {
  @Prop(Boolean) readonly visible: false
  @Prop({default: 'old'}) readonly version: string
  @Prop({ default: () => ([]) }) readonly tenantList: any

  loading = false
  searchTenantKey = '' // 筛选租户
  searchFirmwareKey = '' // 筛选固件
  searchGatewayKey = '' // 筛选网关
  tenantId = ''
  firmwareId = ''
  firmwareList = []
  gatewayList = []
  selectedRowKeys = [] // 选中的网关code
  gatewayLoading = false

  get columns() {
    if (this.version === 'old') {
      return [
        {
          title: 'SN',
          dataIndex: 'code',
          key: 'code',
          width: 131,
          ellipsis: true
        },
        {
          title: this.$t('page_workstation_maintain_name'),
          dataIndex: 'name',
          key: 'name',
          width: 109,
          ellipsis: true
        },
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          ellipsis: true
        }
      ]
    } else {
      return [
        {
          title: 'SN',
          dataIndex: 'code',
          key: 'code',
          width: 131,
          ellipsis: true
        },
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          ellipsis: true
        },
        {
          title: this.$t('page_workstation_maintain_isOnline'),
          dataIndex: 'isOnline',
          key: 'isOnline',
          customRender:(text) =>{
            return (
              <a-tag color={text ? 'green' : 'volcano'}>
                {text ? this.$t('online') : this.$t('offline')}
              </a-tag>
            )
          }
        }
      ]
    }
  }

  get searchTenantList() {
    return this.searchTenantKey ? this.tenantList.filter(item =>
       item.tenantCode.toLowerCase().indexOf(this.searchTenantKey.toLowerCase()) > -1
    ) : this.tenantList
  }

  @Watch('visible')
  onVisibleChange(val) {
    if (val) {
      this.loading = false
      this.tenantId = this.tenantList.length ? this.tenantList[0].tenantId : ''
      this.selectedRowKeys = []
    }
  }

  @Watch('tenantId')
  toggleTenant() {
    this.getData()
    this.fetchGatewayList()
  }

  @Watch('searchGatewayKey')
  filterGateway() {
    this.fetchGatewayList()
  }

  // 固件列表
  async getData(
    current = 1,
    size = -1,
    fileName = this.searchFirmwareKey,
    tenantId = this.tenantId
  ) {
    this.firmwareList = []
    let res
    if(this.version ==='old') {
      res = await firmwareService.getFirmwares(
        current,
        fileName,
        size,
        tenantId,
        ''
      )
    } else {
      res = await fsp.pageFirmware(
        {
          ascs: '',
          current: current,
          descs: '',
          fileName: fileName,
          filter: '',
          size: size,
          tenantId: tenantId,
          version: ''
        } as any
      )
    }
    this.handleData(res.items)
  }

  handleData(data) {
    this.firmwareList = data.map(item => ({ label: item.fileName, value: item.id }))
    this.firmwareId = this.firmwareList.length ? this.firmwareList[0].value : ''
  }

  // 网关列表
  async fetchGatewayList() {
    this.gatewayLoading = true
    if(this.version==='old') {
      this.gatewayList = await tenantGatewayService.getGateways(this.searchGatewayKey, this.tenantId)
    } else {
      const param = {
        ascs: '',
        batchCode: '',
        current: 1,
        descs: '',
        filter: this.searchGatewayKey,
        isOnline: undefined,
        size: -1,
        tenantId: this.tenantId
      } as  PageGatewayDTO
      const { items } = await gsp.findGatewayList(param)
      this.gatewayList = items

    }

    this.gatewayLoading = false
    // console.log('gatewayData:', this.gatewayList)
  }

  // 表格勾选
  onSelectChange(selectedRowKeys, selectedRows) {
    this.selectedRowKeys = selectedRowKeys
  }

  // 发行固件/固件推送
  async save() {
    if(!this.firmwareId) {
      this.$message.error('请选择固件')
      return
    }
    if(!this.selectedRowKeys.length) {
      this.$message.error('请至少选择一个网关')
      return
    }
    this.loading = true
    try {
      if(this.version==='old') {
        let params = new IssueFirmwareDto({
          firmwareId: this.firmwareId,
          gatewayCode: this.selectedRowKeys
        })
        await firmwareService.issueFirmware(params)
      } else {
        let params = new IssueFirmwareDTO({
          firmwareId: this.firmwareId,
          gatewayCodeList: this.selectedRowKeys
        })
        await fsp.issueFirmware(params)
      }

      this.$message.success(this.$t('save_success'))
      this.$emit('close')
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  render() {
    return (
      <a-modal
        onCancel={() => (this.$emit('close'))}
        title={this.$t('page_firmware_management_push_title')}
        visible={this.visible}
        destroyOnClose={true}
        maskClosable={false}
        width={800}
        confirmLoading={this.loading}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => (this.$emit('close'))}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" loading={this.loading} onClick={this.save}>
            {this.$t('page_firmware_management_push')}
          </a-button>
        </div>

        <div class="body-content">
          <div class="left">
            <a-input placeholder={this.$t('page_firmware_management_input_tenant_name')} style="width: 100%"
                     allow-clear={true} v-model={this.searchTenantKey}>
              <a-icon slot="prefix" type="search" style="color: #b5b5b5"/>
            </a-input>
            <ul class="list">
              {this.searchTenantList.map(tenant => {
                return (
                  <li key={tenant.tenantId} class={this.tenantId === tenant.tenantId ? 'select' : ''} onClick={() => {
                    this.tenantId = tenant.tenantId
                  }}>{tenant.tenantCode}</li>
                )
              })}
            </ul>
          </div>

          <div class="right">
            <app-select placeholder="请选择固件" list={this.firmwareList} v-model={this.firmwareId}
                        extraStyle={'width: 100%'} showSearch={true}/>
            <a-input placeholder={this.$t('page_firmware_management_input_keyWords')}
                     style="width: 100%;margin: 16px 0 8px;"
                     allow-clear={true} v-model={this.searchGatewayKey}>
              <a-icon slot="prefix" type="search" style="color: #b5b5b5"/>
            </a-input>

            <ml-table
              size="small"
              rowKey="code"
              defaultExpandAllRows={true}
              canChangeColWidth={true}
              loading={this.gatewayLoading}
              dataSource={this.gatewayList}
              columns={this.columns}
              rowSelection={{
                selectedRowKeys: this.selectedRowKeys,
                onChange: this.onSelectChange
              }}
              scroll={{ y: 418 }}
              pagination={false}
            ></ml-table>
          </div>
        </div>

      </a-modal>
    )
  }
}
